import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCircle2 } from "lucide-react";

import { api, onMembershipRequired } from "@/lib/api";
import { Modal } from "@/components/modal";
import { Button } from "@/components/ui";

const Ctx = createContext({ show: () => {} });
export const usePaywall = () => useContext(Ctx);

const PERKS = ["Send Courtship, Dating & Flirtation requests", "Accept requests you receive", "Connect on WhatsApp + icebreakers", "Save profiles you like"];

/** Any API call that returns 402 "membership_required" opens this dialog. */
export function PaywallProvider({ children }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const show = useCallback(() => setOpen(true), []);
  useEffect(() => onMembershipRequired(show), [show]);
  const { data } = useQuery({ queryKey: ["membership"], queryFn: () => api("/membership"), enabled: open });

  return (
    <Ctx.Provider value={{ show }}>
      {children}
      <Modal open={open} onClose={() => setOpen(false)} title="Continue with LOVE NET Premium" testId="paywall-sheet">
        <p className="mb-4 text-sm text-muted-foreground">Browsing stays free. Premium unlocks the moments that matter:</p>
        {PERKS.map((p) => (
          <div key={p} className="mb-2 flex items-center gap-2 text-sm font-medium"><CheckCircle2 className="h-[18px] w-[18px] text-primary" />{p}</div>
        ))}
        <div className="my-5 grid grid-cols-3 gap-2">
          {data?.plans?.map((p) => (
            <div key={p.id} data-testid={`paywall-plan-${p.id}`} className="rounded-xl border bg-white p-3 text-center">
              <div className="text-xs font-medium text-muted-foreground">{p.name}</div>
              <div className="font-display text-xl font-bold">{p.price_display}</div>
              <div className="h-4 text-[11px] font-bold text-primary">{p.savings_pct ? `Save ${p.savings_pct}%` : ""}</div>
            </div>
          ))}
        </div>
        <Button testId="paywall-see-plans-button" title="See plans" className="w-full" onClick={() => { setOpen(false); navigate("/membership"); }} />
        <Button testId="paywall-dismiss-button" title="Not now" variant="ghost" className="mt-2 w-full" onClick={() => setOpen(false)} />
      </Modal>
    </Ctx.Provider>
  );
}
